// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"eeb3d2b2","787":"2dd64f40"}[chunkId] + ".chunk.js";
};